import apiClient from '../apiClient';

const profileService = {
  // Change password
  changePassword: async (passwordData) => {
    try {
      const response = await apiClient.post('/auth/change-password', passwordData);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default profileService;
